"use strict";
/// <reference path="../../fluxible.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
const BaseStore = require("fluxible/addons/BaseStore");
const clientDebug_1 = require("../clientDebug");
class ApplicationStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.dispatcher = dispatcher;
        this.pageTitle = '';
        this.params = [];
    }
    handlePageTitle(currentRoute) {
        (0, clientDebug_1.trackEvent)('Route_has_been_open_change', { name: currentRoute.name, query: currentRoute.query });
        this.emitChange();
    }
    getPageTitle() {
        return this.pageTitle;
    }
    getPage() {
        return this.page;
    }
    getPath() {
        return this.path;
    }
    setData(data) {
        this.params = data.parameters;
        this.widgets = data.widgets;
    }
    getParams() {
        return this.params;
    }
    getParam(key) {
        for (let param of this.getParams()) {
            if (param.name === key) {
                return param.value;
            }
        }
    }
    getWidgets() {
        return this.widgets;
    }
    dehydrate() {
        return {
            pageTitle: this.pageTitle,
            params: this.params,
            widgets: this.widgets,
        };
    }
    rehydrate(state) {
        this.pageTitle = state.pageTitle;
        this.params = state.params;
        this.widgets = state.widgets;
    }
}
ApplicationStore.storeName = 'ApplicationStore';
ApplicationStore.handlers = { NAVIGATE_SUCCESS: 'handlePageTitle' };
exports.default = ApplicationStore;
function format(text, args) {
    if (!text)
        return '';
    return text.replace(/{(\d+)}/g, (match, num) => {
        return typeof args[num] !== 'undefined'
            ? args[num]
            : match;
    });
}
